import React from 'react';
import { Skeleton } from 'antd';
import { useGetManyOrders } from 'api/orders/use-get-many-orders.ts';
import { useStatePagination } from 'shared/hooks/use-state-pagination.ts';
import { OrdersList } from 'components/orders/orders-list';
import { Pagination } from 'components/pagination';

interface IClientOrdersProps {
  clientId: number;
}

export const ClientOrders: React.FC<IClientOrdersProps> = (props) => {
  const { clientId } = props;

  const { page, limit, handlePageChange } = useStatePagination({ defaultLimit: 20 });

  const {
    data: orders,
    isLoading,
    isPreviousData,
  } = useGetManyOrders({
    page,
    limit,
    filters: { clientId: { value: clientId } },
  });

  return (
    <Skeleton loading={isLoading}>
      <OrdersList orders={orders?.data || []} isLoading={isPreviousData} withoutClient />
      <Pagination total={orders?.pagination?.total} page={page} limit={limit} onChange={handlePageChange} />
    </Skeleton>
  );
};
